// extracted by mini-css-extract-plugin
export var addButton = "_fk-0";
export var border = "_fk-8";
export var check = "_fk-h";
export var danger = "_fk-6";
export var dropdownContainer = "_fk-1";
export var editModalBody = "_fk-j";
export var footerContainer = "_fk-i";
export var fullWidth = "_fk-a";
export var hide = "_fk-9";
export var icon = "_fk-3";
export var input = "_fk-7";
export var inputFlex = "_fk-b";
export var inputWrapper = "_fk-c";
export var manualFocus = "_fk-5";
export var optionButton = "_fk-4";
export var pillWrapper = "_fk-e";
export var pointer = "_fk-2";
export var showOverflow = "_fk-f";
export var tagsFlex = "_fk-d";
export var xButton = "_fk-g";